import { render } from "./mPayPage.vue?vue&type=template&id=db4c73e2&scoped=true"
import script from "./mPayPage.vue?vue&type=script&lang=js"
export * from "./mPayPage.vue?vue&type=script&lang=js"

import "./mPayPage.vue?vue&type=style&index=0&id=db4c73e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db4c73e2"]])

export default __exports__